import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import VueMarkdown from 'vue-markdown';
import Loading from '@/components/Loading.vue';
import BackButton from '@/components/BackButton.vue';
const starshipSizeModule = namespace('starshipSizes');
let StarshipSizeDetails = class StarshipSizeDetails extends Vue {
    created() {
        this.fetchStarshipSizes();
    }
    get title() {
        return this.sizeName + ' | Starships' + Vue.prototype.$titleSuffix;
    }
    get starshipSizeData() {
        return this.starshipSizes.find(({ name }) => name === this.sizeName);
    }
};
__decorate([
    starshipSizeModule.State
], StarshipSizeDetails.prototype, "starshipSizes", void 0);
__decorate([
    starshipSizeModule.Action
], StarshipSizeDetails.prototype, "fetchStarshipSizes", void 0);
__decorate([
    Prop(String)
], StarshipSizeDetails.prototype, "sizeName", void 0);
StarshipSizeDetails = __decorate([
    Component({
        components: {
            VueMarkdown,
            BackButton,
            Loading
        }
    })
], StarshipSizeDetails);
export default StarshipSizeDetails;
